module.exports = __webpack_public_path__ + "static/media/pla_green_gaint_straw1.af6b954a.png";